<template>
    <div>
        <!-- 忘记密码修改界面 -->
        <div class="layui-container login-container">
            <div class="login-form">
                <el-form :model="form" ref="ruleForm" class="layui-form layui-form-pane1">
                    <h1>修改密码</h1>
                    <div class="layui-form-item">
                        <label class="layui-form-label">
                            <b style="color: red">*</b> 用户手机</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.username" autocomplete="off" placeholder="请输入注册手机号"></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"><b style="color: red">*</b> 录入密码</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.password" autocomplete="off" show-password placeholder="请输入修改的密码"></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"><b style="color: red">*</b> 确认密码</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.passwordCp" autocomplete="off" show-password placeholder="请再次确认新密码"></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">
                            <b style="color: red">*</b>图形验证</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.captcha" autocomplete="off" placeholder="请输入图形验证码" style="width:156px;float: left"></el-input>
                            <img style="border-radius: 3px;float: left;margin-left: 10px;cursor: pointer;border: #cccccc 1px solid;" alt="验证码" ref="codeImg" id="codeImg" src="" width="130"
                                 height="39" @click="changeCode()"/>
                        </div>
                    </div>
                    <div id="sms" class="layui-form-item">
                        <label class="layui-form-label">
                            <b style="color: red">*</b> 短信验证</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.smsCode" autocomplete="off" placeholder="请输入短信验证码" style="width:156px;float: left"></el-input>
                            <el-button type="primary" plain style="margin-left: 10px;width: 130px" @click="sendSmsCode">发送验证码</el-button>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"></label>
                        <div class="layui-input-inline">
                            <button class="layui-btn" type="button" @click="formSubmit();" style="float: left">
                                提交修改
                            </button>
                            <div style="float: right;margin-top: 15px;margin-right: 100px">
                                <a style="color: #5290ff; font-size: 12px;cursor: pointer" href="javascript:void(0)" @click="handleLogin">返回登录</a>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                token:'',
                form: {
                    username: '',
                    password: '',
                    passwordCp: '',
                    captcha: '',
                    smsCode: ''
                }
            };
        },
        methods: {
            changeCode() {
                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/getCaptcha',
                    data: {},
                    responseType: 'blob'
                }).then(res => {
                    let img = this.$refs.codeImg;
                    let url = window.URL.createObjectURL(res.data);
                    img.src = url;
                    this.token = res.headers['access-token'];
                });
            },
            sendSmsCode() {//发送验证码

                if(!this.form.username){
                    this.$notify({
                        title: '请输入手机号！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.captcha){
                    this.$notify({
                        title: '请输入图形验证码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }

                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/sendSmsCode',
                    data: this.form,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Token': this.token  //将token放在请求头带到后端
                    }
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$message({
                            type: 'success',
                            message: "发送成功，5分钟有效！"
                        });
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                        this.form.captcha = '';
                        this.changeCode();
                    }
                })
            },
            handleLogin() {
                this.$emit('handleToggleTab', 5);
            },
            formSubmit() {

                if(!this.form.username){
                    this.$notify({
                        title: '请输入手机号！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.password){
                    this.$notify({
                        title: '请输入登录密码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.passwordCp){
                    this.$notify({
                        title: '请确认登录密码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.captcha){
                    this.$notify({
                        title: '请输入图形验证码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.smsCode){
                    this.$notify({
                        title: '请输入短信验证码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }

                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/updatePw',
                    data: this.form,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Token': this.token  //将token放在请求头带到后端
                    }
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$confirm('密码修改成功,是否跳转登录页?', '提示', {
                            confirmButtonText: '跳转登录',
                            cancelButtonText: '取消',
                            type: 'success'
                        }).then(() => {
                            this.handleLogin();
                        }).catch(() => {

                        });
                    } else {
                        this.$notify({
                            title: res.data.msg,
                            type: 'error',
                            offset: 600
                        });
                        this.form.captcha = '';
                        this.changeCode();
                    }
                })
            }
        },
        created() {
            this.changeCode();
        }
    };
</script>